import React from 'react';
// import PropTypes from 'prop-types';

// Components
import ErrorBoundary from 'components/_shared/ErrorBoundary/ErrorBoundary';
import Button from 'components/_shared/Button/Button';

// SVGs
import { ReactComponent as Collapse } from 'svgs/less_icon.svg';
import { ReactComponent as Expand } from 'svgs/more_icon.svg';

// Constants
// Styles
import './ProviderFilter.css';

export default class ProviderFilter extends React.Component {
  // Prop Types
  // ------------------------------------------------------------------------ //
  static propTypes = {};
  static defaultProps = {};

  // Constructor
  // ------------------------------------------------------------------------ //

  // Variables
  // ------------------------------------------------------------------------ //
  state = {
    effects: false,
    visibleFilters: [],
  }

  // Lifecycle methods
  // ------------------------------------------------------------------------ //
  componentDidMount() {
    // effects
    if (this.props.refresh || this.props.overlayData.spa || this.props.overlayData.hood) {
      this.toggleExpander(null, 'effects')
    }

    // filters
    let selectedFilters = Object.keys(this.props.filters)
      .filter(filter => this.props.filters[filter].length)

    if (selectedFilters.length) {
      this.batchExpander(null, selectedFilters)
    }
  }

  // Event handlers
  // ------------------------------------------------------------------------ //
  batchExpander = (e, types) => {
    // if (e) e.preventDefault();
    let visibleFilters = [...this.state.visibleFilters]
    visibleFilters = visibleFilters.concat(types)
    this.setState({visibleFilters})
  }

  toggleExpander = (e, type) => {
    // if (e) e.preventDefault();
    if (type === 'effects') {
      this.setState({[type]: !this.state[type]})
    } else {
      let visibleFilters = [...this.state.visibleFilters]
      if (visibleFilters.indexOf(type) > -1) {
        visibleFilters = visibleFilters.filter(filt => filt !== type)
      } else {
        visibleFilters = visibleFilters.concat(type)
      }
      this.setState({visibleFilters})
    }
  }

  // Class methods
  // ------------------------------------------------------------------------ //

  // Render methods
  // ------------------------------------------------------------------------ //
  buildFilterCheckboxes = type => {
    return (
      <ul className={`providers__${type}-filters`}>
        {this.props.staticData[type].map((filter, idx) => (
          <li key={`${filter.split(' ')[0]}_${idx}`} className="providers__filter">
            <label>
              <input
                type="checkbox"
                checked={this.props.filters[type].indexOf(filter) > -1}
                onChange={e => this.props.handleFilter(e, {
                    type,
                    filter
                  })} />
              <span className="fake-input"></span>
            </label>
            <p>{filter === 'higher education' ? 'post-secondary education' : filter}</p>
          </li>
        )) }
      </ul>
    )
  }


  render() {
    return (
      <ErrorBoundary>
        <div className="providers__options">
          <div className="providers__effects">
            <div className="providers__filter-header">
              <h2>Effects</h2>
              { <div className="providers__expand-icon" onClick={e => this.toggleExpander(e, 'effects')}>
                  {this.state.effects ? (<Collapse/>) : (<Expand />) }
                </div>
              }
            </div>
            {this.state.effects ?
              (
                <ul className="providers__effects-list">
                  <li className="providers__effect">
                    <label>
                      <input
                        type="checkbox"
                        checked={this.props.refresh}
                        onChange={e => this.props.toggleCheckbox(e, 'refresh')}/>
                      <span className="fake-input"></span>
                    </label>
                    <p>Refresh map when repositioned</p>
                  </li>
                  <li className="providers__effect">
                    <label>
                      <input
                        type="checkbox"
                        checked={this.props.overlayData.spa}
                        onChange={e => this.props.toggleOverlay(e, 'spa')}/>
                      <span className="fake-input"></span>
                    </label>
                    <p>Show SPAs overlay</p>
                  </li>
                  <li className="providers__effect">
                    <label>
                      <input
                        type="checkbox"
                        checked={this.props.overlayData.hood}
                        onChange={e => this.props.toggleOverlay(e, 'hood')}/>
                      <span className="fake-input"></span>
                    </label>
                    <p>Show Neighborhoods overlay</p>
                  </li>
                </ul>
              )
              : null
            }
          </div>

          {
            Object.keys(this.props.staticData)
            .filter(filter => Object.keys(this.props.filters).indexOf(filter) > -1)
            .map(filter => (
              <div key={filter} className={`
                providers__filters
                providers__${filter}`}>
                <div className="providers__filter-header">
                  <h2>{ this.props.staticData.titles[filter] }</h2>
                  { <div
                      className="providers__expand-icon"
                      onClick={e => this.toggleExpander(e, filter)}>
                      {this.state.visibleFilters.indexOf(filter) > -1 ? (<Collapse />) : (<Expand />) }
                    </div>
                  }
                </div>
                {this.state.visibleFilters.indexOf(filter) > -1 ?
                  (
                    <React.Fragment>
                      {this.buildFilterCheckboxes(filter)}
                    </React.Fragment>
                  )
                  : null
                }
              </div>
            ))
          }
          <div className="providers__filters-ctas">
            <Button
              hollow={true}
              className="providers__filters-btn"
              value="Clear All"
              onClick={this.props.resetFilters}
            />
          {/*<Button
              className="providers__filters-btn"
              value="Apply"
              onClick={this.props.applyFilters}
            /> */}
          </div>

        </div>
      </ErrorBoundary>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Directory/ProviderFilter/ProviderFilter.js